export function setFeatures(data) {
  return {
    type: 'SET_FEATURES',
    payload: data,
  }
}
